<template>
  <div v-if="inhabitantChange">
    <v-badge inline color="red" :content="inhabitantChange">{{ text }}</v-badge>
  </div>
  <div v-else>
    {{ text }}
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Badge',

  components: {},

  props: {
    text: {
      type: String,
      required: true
    }
  },

  data: () => ({}),

  computed: {
    ...mapState('new_inhabitant_changes', ['inhabitantChange'])
  },
  mounted() {
    this.getActualQuantity();
  },

  created() {
    this.getQuantity();
  },

  methods: {
    ...mapActions('new_inhabitant_changes', [
      'getQuantity',
      'getActualQuantity'
    ])
  }
};
</script>
